<template>
  <DxPopup
    :visible.sync="getVisible"
    :drag-enabled="true"
    :close-on-outside-click="false"
    :show-title="true"
    :width="'90%'"
    :height="'80%'"
    :title="'Product History Detail'"
    @hidden="popupHidden"
    @shown="onShown"
    :showCloseButton="false"
    :wrapperAttr="{
      class: 'css-v2 gc-popup gc-popup-customer-product-history',
    }"
  >
    <DxToolbarItem
      location="before"
      :html="
        `<span class='toolbar-title-secondary text-secondary'> ` +
        (dataObj.ProductDescription1 + ' (' + dataObj.ProductCode + ')') +
        ` </span>`
      "
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />
    <div class="css-v2 transaction-list" :v-if="loaded">
      <GcDataGrid
        :grouping="true"
        :export="true"
        :summary="true"
        :dataSourceConfig="dataSourceConfig"
        :columns="gridColumns"
        :id="'model'"
        ref="transactionListGrid"
        :isLocalDataSource="false"
        :isEditableGrid="false"
        :showFooter="false"
        :gridOptions="getGridOptions"
        :gridToolbar="getToolbar"
        :exportFileName="`Product History Detail - ${dataObj.ProductCode}`"
        :gridHeightOverWrite="filterHeightAdjustment - 2"
        :defaultUserSettings="true"
        :title="'Product History Detail'"
        :save-grid-layout="true"
        :key="gridKey"
        :filterHeightAdjustment="filterHeightAdjustment - 2"
        :persistenceKey="persistenceKey"
        :saveGridLayout="false"
        v-if="loaded"
      />
    </div>
  </DxPopup>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";

export default {
  props: {
    setVisible: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Function,
      default: () => {},
    },
    dataObj: {
      type: Object,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    filterByCustomer: {
      type: Boolean,
      default: false,
    },
    persistenceKey: {
      type: String,
      default: undefined,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin, DataGridMixin],
  data() {
    return {
      showLeftContainer: true,
      showRightContainer: true,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
          },
        },
      },
      defaultFilterValues: [],
      filterHeightAdjustment: 0,
      productCategory3Filter: [],
      productFilter: [],
      selectedProduct: null,
      gridKey: new Date().getTime(),
      loaded: false,
      gridColumns: [],
    };
  },
  beforeMount() {
    this.selectedProduct = this.dataObj.ProductCode;
    this.defaultFilterValues = [["ProductCode", "=", this.selectedProduct]];
    if (this.filterByCustomer && this.dataObj.CustomerCode) {
      this.defaultFilterValues.push("and");
      this.defaultFilterValues.push([
        "CustomerCode",
        "=",
        this.dataObj.CustomerCode,
      ]);
    }
    this.gridColumns = this.buildGridColumns(); // initialize columns as data
  },
  async mounted() {},
  async created() {
    setTimeout(() => {
      this.filterHeightAdjustment =
        document.querySelectorAll(
          ".gc-popup-customer-product-history .dx-popup-content",
        )[0].clientHeight - 20;
    }, 1);
  },
  computed: {
    getVisible: {
      get() {
        return this.setVisible;
      },
      set() {
        return false;
      },
    },
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            icon: "close",
            onClick: this.popupHidden,
            visible: true,
          },
        },
      ];
    },

    getToolbar() {
      return {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        expand: false,
        filterOnEnter: true,
      };
    },

    getGridOptions() {
      return {
        options: {
          selectionMode: "none",
        },
      };
    },

    dataSourceConfig() {
      return {
        endpoint: "CustomerProductHistoryDetailList",
        serverPaging: true,
        allowGrouping: false,
        // key: "BinCardNo",
        keyType: {
          InStorageLocationSiteRecordId: "Guid",
          InStorageLocationBuildingRecordId: "Guid",
          InStorageLocationAreaRecordId: "Guid",
        },
        filter:
          this.filterByCustomer && this.dataObj.CustomerCode
            ? [
                ["ProductCode", "=", this.selectedProduct],
                "and",
                ["CustomerCode", "=", this.dataObj.CustomerCode],
              ]
            : [["ProductCode", "=", this.selectedProduct]],
        select: [
          "DiscountPcnt",
          "FXCurrency",
          "InvoiceNo",
          "MovementDate",
          "PriceGroupId",
          "PriceGroupShortDescription",
          "ProductCode",
          "ProductDescription1",
          "SalesOrder",
          "SalesUM",
          "SalesUMQty",
          "UnitPriceBase",
          "UnitPriceFX",
          "CustomerCode",
          "CustomerName",
          "ExTotalBase",
          "TaxBase",
          "IncTotalBase",
          "ExTotalFX",
          "TaxFX",
          "IncTotalFX",
          "SalesUMStandardPriceBase",
          "SalesUMStandardPriceFX",
          "GrossProfitPcnt",
          "GrossProfitBase",
          "SalesUMStandardCost",
        ],
      };
    },

    /**
     * Retun filter panel form items
     * filterIndex field does have an impact , because we directly inject the fields in to the filter panel.
     * since it's a direct inject, field order is the order we define it. - SD
     */
    filterFormItems() {
      return [
        ...(!this.filterByCustomer
          ? [
              {
                screenField: "Customer",
                filterIndex: 1,
              },
            ]
          : []),
        {
          screenField: "Invoice",
          filterIndex: 2,
          filterDataField: "InvoiceNo",
          filterLabel: "Invoice #",
          type: "Integer",
        },
        {
          screenField: "Invoice",
          filterLabel: "Sales Order #",
          filterIndex: 3,
          filterDataField: "SalesOrder",
          type: "Integer",
        },
        ...(!this.filterByCustomer
          ? [
              {
                screenField: "CustomerGroup",
                filterLabel: "Customer Group",
                filterDataField: "CustomerGroup",
                filterIndex: 4,
              },
              {
                screenField: "CustomerType",
                filterLabel: "Customer Type",
                filterDataField: "CustomerType",
                filterIndex: 5,
              },
              {
                screenField: "Market",
                filterLabel: "Customer Market",
                filterDataField: "CustomerMarket",
                filterIndex: 6,
              },
              {
                screenField: "Region",
                filterLabel: "Customer Region",
                filterDataField: "CustomerRegionCode",
                filterIndex: 7,
              },
              {
                screenField: "SubRegion",
                filterLabel: "Customer Sub Region",
                filterDataField: "CustomerSubregionCode",
                filterIndex: 8,
              },
            ]
          : []),
      ];
    },
  },
  methods: {
    popupHidden() {
      if (this.hidden) this.hidden();
    },

    async onShown() {
      if (this.columns && this.columns.length > 0) {
        const visibleColumns = this.columns.filter(
          (col) => col.visible != false,
        );

        this.gridColumns.forEach((col) => {
          const matchedCol = visibleColumns.find(
            (c) =>
              (c.dataField === col.dataField ||
                c.gridDataField === col.dataField) &&
              col.showInColumnChooser !== false,
          );

          if (matchedCol) {
            col.visible = matchedCol.visible;
            col.visibleIndex = matchedCol.visibleIndex;
          } else {
            col.visible = false; // hide columns that are not in the provided columns list
          }
        });
      }

      if (this.filters) {
        this.gridColumns.forEach((col) => {
          if (
            col.filterDataField &&
            col.filterIndex &&
            this.filters[col.filterDataField]
          ) {
            if (Array.isArray(this.filters[col.filterDataField])) {
              if (this.filters[col.filterDataField].length > 0) {
                col.filterDefaultValue = this.filters[col.filterDataField];
              }
            } else {
              if (this.filters[col.filterDataField]) {
                col.filterDefaultValue = this.filters[col.filterDataField];
              }
            }
          }
        });
      }

      setTimeout(() => {
        this.$nextTick(() => {
          this.loaded = true;
        });
      }, 100);
    },

    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          validationGroup: "formsData",
          icon: "filter",
          elementAttr: { id: "filter-btn" },
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            this.$logger.debug("item ", item);
            item.classList.add("dx-state-invisible");

            setTimeout(() => {
              this.reSizeGrid();
            }, 50);
          },
          visible: !this.showRightContainer,
        },
      });
    },

    buildGridColumns() {
      return [
        {
          screenField: "Date",
          sortOrder: "desc",
          dataField: "MovementDate",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
          label: "Date",
        },
        {
          screenField: "Invoice",
          dataField: "InvoiceNo",
          label: "Invoice #",
          hyperlink: {
            url: `invoice/review/__ID__`,
            dataField: "InvoiceNo",
            target: "_blank",
          },
          width: ColumnWidth.InvoiceNumber.width,
          minWidth: ColumnWidth.InvoiceNumber.minWidth,
          filterIndex: 2,
          type: "Integer",
          filterLabel: "Invoice #",
          filterDataField: "InvoiceNo",
        },
        {
          screenField: "Invoice",
          label: "Sales Order #",
          dataField: "SalesOrder",
          hyperlink: {
            url: `sales-order/review/__ID__`,
            dataField: "SalesOrder",
            target: "_blank",
          },
          width: ColumnWidth.SalesOrderNumber.width,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth,
          filterIndex: 3,
          type: "Integer",
          filterLabel: "Sales Order #",
          filterDataField: "SalesOrder",
        },
        {
          screenField: "Customer",
          dataField: "CustomerName",
          filterDataField: "CustomerCode",
          width: 200,
          minWidth: 200,
          visible: !this.filterByCustomer,
          filterIndex: !this.filterByCustomer ? 1 : undefined,
          showInColumnChooser: !this.filterByCustomer,
        },
        {
          screenField: "SalesUM",
          label: "Sales UM",
          dataField: "SalesUM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          width: ColumnWidth.UnitOfMeasure.width,
        },
        {
          screenField: "SalesUMQty",
          dataField: "SalesUMQty",
          label: "Sales UM Qty",
          minWidth: ColumnWidth.Quantity.minWidth,
          width: ColumnWidth.Quantity.width,
        },
        {
          dataField: "FXCurrency",
          label: "Currency",
          minWidth: ColumnWidth.CurrencyCode.minWidth,
          width: ColumnWidth.CurrencyCode.width,
        },
        {
          dataField: "SalesUMStandardCost",
          label: "Sales UM Std Cost (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "SalesUMStandardPriceBase",
          label: "Sales UM Std Price (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "SalesUMStandardPriceFX",
          label: "Sales UM Std Price (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "UnitPriceFX",
          label: "Sales UM Price (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "UnitPriceBase",
          label: "Sales UM Price (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "ExTotalFX",
          label: "Ex Total (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "TaxFX",
          label: "Tax (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "IncTotalFX",
          label: "Inc Total (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "ExTotalBase",
          label: "Ex Total (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "TaxBase",
          label: "Tax (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "IncTotalBase",
          label: "Inc Total (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "GrossProfitPcnt",
          label: "GP %",
          type: "Decimal",
          cellTemplate: "Decimal",
          format: "Decimal-16-2P",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "GrossProfitBase",
          label: "GP (Base Currency)",
          type: "Decimal",
          cellTemplate: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          screenField: "PriceGroup",
          dataField: "PriceGroupId",
          width: 200,
          minWidth: 200,
          cellTemplateRecord: {
            primary: [
              {
                dataField: "PriceGroupShortDescription",
              },
            ],
            secondary: [
              {
                dataField: "PriceGroupId",
              },
            ],
          },
          exportFields: [
            {
              dataField: "PriceGroupId",
              label: "Price Group Code",
            },
            {
              dataField: "PriceGroupShortDescription",
              label: "Price Group Description",
            },
          ],
        },
        // For Filtering purpose only, not visible in the grid
        {
          screenField: "CustomerGroup",
          filterLabel: "Customer Group",
          filterDataField: "CustomerGroup",
          filterIndex: !this.filterByCustomer ? 4 : undefined,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "CustomerType",
          filterLabel: "Customer Type",
          filterDataField: "CustomerType",
          filterIndex: !this.filterByCustomer ? 5 : undefined,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "Market",
          filterLabel: "Customer Market",
          filterDataField: "CustomerMarket",
          filterIndex: !this.filterByCustomer ? 6 : undefined,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "Region",
          filterLabel: "Customer Region",
          filterDataField: "CustomerRegionCode",
          filterIndex: !this.filterByCustomer ? 7 : undefined,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "SubRegion",
          filterLabel: "Customer Sub Region",
          filterDataField: "CustomerSubregionCode",
          filterIndex: !this.filterByCustomer ? 8 : undefined,
          visible: false,
          showInColumnChooser: false,
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.gc-popup-customer-product-history {
  .footer {
    .dx-button:first-child {
      margin-right: 12px;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .advance-filter-panel .dx-form {
    padding-bottom: 10px !important;
  }
}
</style>
